module.exports = __webpack_public_path__ + "images/dockr2274041e1326341042b51846548cb0eb.png";